'use client';

import { type ReactNode, type ChangeEventHandler } from 'react';
import Filter from 'components/controls/filters/filter';
import styles from './filterset.module.scss';
import ScreenReaderOnly from 'components/accesibility/screen-reader-only';

function FilterSet(props: FilterSetProps) {
	const wrapperClasses = props.wrap
		? `${styles.wrapper} ${styles.wrap}`
		: styles.wrapper;

	return (
		<div className={wrapperClasses}>
			{props.sideForChildren != 'right' && props.children}
			<fieldset className={styles.fieldset}>
				<ScreenReaderOnly Element="legend" text={props.screenReaderLegend} />
				{props.labelText && (
					<span className={styles.label}>{props.labelText}</span>
				)}
				<div className={styles.filterSet}>
					{props.filterOptions.map((filterObj) => {
						return (
							<Filter
								key={filterObj.value}
								filterFor={props.filtersFor}
								filterName={filterObj.name}
								filterValue={filterObj.value}
								checked={!!props.filterState[filterObj.value]}
								handleInputChange={props.handleInputChange}
							/>
						);
					})}
				</div>
			</fieldset>
			{props.sideForChildren == 'right' && props.children}
		</div>
	);
}

export interface FilterSetProps {
	filterOptions: { name: string; value: string }[];
	filterState: Record<string, boolean>;
	handleInputChange: ChangeEventHandler<HTMLInputElement>;
	children?: ReactNode;
	filtersFor?: string;
	screenReaderLegend?: string;
	sideForChildren?: string;
	wrap?: boolean;
	labelText?: string;
}

export default FilterSet;
